import axios from 'axios';
import config from '../config';

const instanceWD = axios.create({
  baseURL: config.baseURLWD,
  //withCredentials: true
});

const instanceAP = axios.create({
  baseURL: config.baseURLStrapi,
  //withCredentials: true
});



export {instanceWD, instanceAP};
